import { Component } from '@angular/core';
import { Select } from '@ngxs/store';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ProjectModel } from '../../../project.models';
import { ProjectsState } from '../../../project.state';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { DisplayType } from 'src/app/shared/components/ed-table/ed-table.component';
import { MatTableDataSource } from '@angular/material/table';

@UntilDestroy()
@Component({
    selector: 'project-timesheets',
    templateUrl: './project-timesheets.component.html',
    styleUrls: ['./project-timesheets.component.scss'],
    standalone: true,
    schemas: [],
    imports: [CommonModule, SharedModule, RouterModule],
    providers: [],
})
export class ProjectTimesheetsComponent {
    @Select(ProjectsState.projectWithDetail)
    public project$!: Observable<ProjectModel>;
    public project: ProjectModel | undefined;

    public monthlyTimeData = new MatTableDataSource<{}>([]);
    public monthlyTimeColumns: any[] = [];

    constructor(private readonly router: Router) {
        this.project$.pipe(untilDestroyed(this)).subscribe((project: ProjectModel) => {
            if (!project) return;
            this.project = project;
            this.generateMonthlyTimeData();
        });
    }

    public generateMonthlyTimeData() {
        if (!this.project || !this.project.phases) return;
        let monthlyTimeColumns: any[] = [];
        const monthlyTimeData: any[] = [];

        for (const phase of this.project.phases) {
            for (const entry of phase.dailyTimeEntries) {
                const dateKey: string = `${new Date(entry.date).getFullYear()}-${String(new Date(entry.date).getMonth() + 1).padStart(2, '0')}`;

                if (!monthlyTimeColumns.find((m) => m.objectKey === dateKey)) {
                    monthlyTimeColumns.push({
                        displayType: DisplayType.NUMBER,
                        objectDisplayName: dateKey,
                        objectKey: dateKey,
                        bold: false,
                    });
                }

                const user = entry.user;
                if (!user) continue;
                const exist = monthlyTimeData.find((u) => u.id === user.id);
                if (exist) {
                    exist[dateKey] = (exist[dateKey] ?? 0) + entry.percentOfDay;
                    exist.total += entry.percentOfDay;
                } else {
                    monthlyTimeData.push({
                        id: user.id,
                        contributorName: `${user.firstname} ${user.lastname} `,
                        [dateKey]: entry.percentOfDay || 0,
                        total: entry.percentOfDay || 0,
                    });
                }
            }
        }
        monthlyTimeColumns = monthlyTimeColumns.sort((a, b) =>
            a.objectKey < b.objectKey ? -1 : 1,
        );
        this.monthlyTimeColumns = [
            {
                displayType: DisplayType.TEXT,
                objectDisplayName: 'Contributeur',
                objectKey: 'contributorName',
                bold: true,
            },
            {
                displayType: DisplayType.NUMBER,
                objectDisplayName: 'Total',
                objectKey: 'total',
                bold: true,
            },
            ...monthlyTimeColumns,
        ];

        if (this.project.legacyReportedDays && this.project.legacyReportedDays > 0) {
            monthlyTimeData.push({
                id: null,
                contributorName: 'Import ASA',
                total: this.project.legacyReportedDays,
            });
        }
        this.monthlyTimeData = new MatTableDataSource<{}>(monthlyTimeData);
    }

    public goToContributor(userId: any) {
        if (!userId) return;
        this.router.navigate([`/main/timesheet/contributor/${userId}`]);
    }
}
